import type { Camera, Scene, SceneControl } from '@anov/3d-core'

class ControlBaseModule {
  camera: Camera
  sceneControl: SceneControl

  constructor(camera: Camera, sceneControl: SceneControl) {
    this.camera = camera
    this.sceneControl = sceneControl
  }
}

export class ControlThirdModule extends ControlBaseModule {
  scene: Scene
  constructor(camera: Camera, scene: Scene, sceneControl?: SceneControl) {
    super(camera, sceneControl)
    this.scene = scene
  }
}

export default ControlBaseModule
